export enum TypeDeliveryEnum {
  MARYLEBONE = 'MARYLEBONE',
  SOUTHKEN = 'SOUTH KEN',
  NOTTINGHILL = 'NOTTING HILL',
  CHELSEA = 'CHELSEA',
}